export const http = {
    state: {
        loading: 0
    },
    getters: {
        isLoading: state => state.loading > 0
    },
    mutations: {
        startLoading: state => {
            console.log('Store[HTTP]: Start loading');
            state.loading++;
        },
        finishLoading: state => {
            console.log('Store[HTTP]: Finished loading');
            state.loading--;
        }
    }
}